import React from 'react';
import PropTypes from 'prop-types';
import { Loading } from '@folio/stripes-components';
import useDefaultFields from '../../../../hooks/useDefaultFields';
import FieldsList from '../../../FieldsList';

function DefaultSchemeList({ fieldArrayName, parentFields }) {
  const { groupedFields, isLoading } = useDefaultFields();

  const entityTypes = {
    instance: groupedFields.instance,
    holdings: groupedFields.holding,
    items: groupedFields.item,
  };
  const defaultScheme = entityTypes[fieldArrayName] || [];

  return (
    <>
      {isLoading && <Loading />}
      {!isLoading && (
        <FieldsList
          contentData={defaultScheme}
          schema="default"
          parentFields={parentFields}
        />
      )}
    </>
  );
}

DefaultSchemeList.propTypes = {
  fieldArrayName: PropTypes.string,
  parentFields: PropTypes.object,
};

export default DefaultSchemeList;
